import { darkTheme } from 'components/App/App.theme';

export const PIECHART_COLORS = [
  darkTheme.customColors.peas,
  darkTheme.customColors.sky,
  darkTheme.customColors.peach,
  darkTheme.customColors.khaki,
  darkTheme.customColors.yellow,
  darkTheme.customColors.darkPurple,
  darkTheme.customColors.lightGreen,
  darkTheme.customColors.magenta,
  darkTheme.customColors.red,
  darkTheme.customColors.darkBrown,
];

export const freeSpaceColor = darkTheme.customColors.lightGrey;

export function getPieChartColor(index) {
  return PIECHART_COLORS[index % PIECHART_COLORS.length];
}

export default PIECHART_COLORS;
